import {useLocation} from 'react-router-dom';
import {useEffect, useState} from 'react'
import VaccinationService, {VaccinationItemType} from "./vaccinationService";
import icon_app_icon from '../../source/image/common/icon_app_icon.png'
import {getOS, OSType} from "../../common/customEnum";

const Vaccination = () => {
	const {pathname} = useLocation()
	const [dataSource, setDateSource] = useState([])
	const [isTokenExpire, setIsTokenExpire] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const vaccinationService = new VaccinationService()

	const paths = pathname.split('/')
	const token = paths.length ? paths[paths.length - 1] : ""

	useEffect(() => {
		if (token) {
			const param = {
				Token: token
			}
			setIsLoading(true)
			vaccinationService.getVaccinationList(param, (data) => {
				setIsLoading(false)
				setDateSource(data)
				setIsTokenExpire(!data.length)
			}, () => {
				setIsLoading(false)
			})
		}
	}, [])

	const onClickOpenApp = () => {
		const url = (getOS() === OSType.macOS || getOS() === OSType.ios || getOS() === OSType.linux) ? 'https://itunes.apple.com/us/app/viphealth/id1265405734?mt=8' : 'https://play.google.com/store/apps/details?id=com.react_viphealth'
		window.open(url)
	}

	const renderNavBar = () => {
		return(
			<div className={'w-full relative'}>
				<div className={'fixed w-full flex flex-row items-center justify-between border-b px-8 py-0.5 bg-white'}>
					<div className={' py-2 flex flex-row items-center justify-center'}>
						<img src={icon_app_icon} className={'h-10 w-10 rounded'} alt={""}/>
						<div className={'ml-2.5 flex flex-col justify-center'}>
							<p className={'text-lg text-black font-semibold'}>{'iClinicHealth'}</p>
							<p className={'text-xs text-darkGray font-medium'}>{'Health management made simple...'}</p>
						</div>
					</div>
					<button onClick={onClickOpenApp} type={'button'} className={'rounded-full py-2 px-4 text-xl font-semibold bg-primary text-white'}>
						Open
					</button>
				</div>
			</div>
		)
	}

	const renderSectionHeader = (item, idx) => {
		const {name, due} = item
		const nextDue = due && due.length ? ('Next Due: ' + due) : ''
		return(
			<div key={idx} className={'flex flex-col px-8 bg-systemGray'}>
				<p className={'font-lg text-black font-bold'}>{name}</p>
				<p className={'font-lg text-red-500 font-semibold'}>{nextDue}</p>
			</div>
		)
	}

	const renderItem = (item, idx) => {
		const {ADate, VaccineName, ClinicName} = item
		return(
			<div key={idx} className={'flex flex-row items-center justify-center bg-systemGray px-8'}>
				<div className={'mb-2.5 w-full rounded bg-white '}>
					<div className={'w-full'}>
						<p className={'text-lg text-primary ml-2'}>{ADate}</p>
						<div className={'w-full h-px bg-systemGray'}/>
					</div>

					<div className={'px-2'}>
						<p className={'text-lg text-black font-medium'}>{VaccineName}</p>
						<p className={'text-darkGray text-lg'} >{ClinicName}</p>
					</div>
				</div>
			</div>
		)
	}

	const renderContent = (item, idx) => {
		const {type} = item
		if (type === VaccinationItemType.header) {
			return renderSectionHeader(item, idx)
		}else {
			return renderItem(item, idx)
		}
	}

	const renderTokenExpire = () => {
		return (
			<div className={'pt-24 w-full h-full flex flex-col items-center px-8'}>
				<p className={'text-lg text-black font-semibold'}>Token Invalid</p>
				<p className={'text-lg text-black font-base mt-2'}>This sharing token is not valid. Please re-request the token in the Vaccines module of the iClinicHealth app..</p>
			</div>
		)
	}

	return (
		<div className={`w-full h-full ${isLoading ? 'animate-pulse' : ''}`}>
			{renderNavBar()}
			<div className={'w-full h-full flex flex-row items-center justify-center '}>
				<div className={'w-full max-w-screen-md'}>
					{dataSource.length ? (
						<div className={'w-full pt-20 pb-8 bg-systemGray'}>
							{dataSource.map((item, idx) => {
								return renderContent(item, idx)
							})}
						</div>
					) : (isTokenExpire ? renderTokenExpire() : null) }
				</div>
			</div>
		</div>
	)
}

export default Vaccination
